import {
	ERROR_LOCATION__CUSTOMIZATION_MODAL,
	ERROR_LOCATION__DRAG_AND_DROP,
	ERROR_LOCATION__GLOBAL_MORE_MENU,
	ERROR_LOCATION__GLOBAL_SHORTCUTS,
	ERROR_LOCATION__GLOBAL_SIDE_NAVIGATION,
} from '../../../constants';

import {
	customizationMessages,
	defaultMessages,
	dndMessages,
	moreMenuMessages,
	shortcutsMessages,
	sideNavMessages,
} from './messages';

export function useMessagesForLocation(location?: string) {
	switch (location) {
		case ERROR_LOCATION__CUSTOMIZATION_MODAL:
			return customizationMessages;
		case ERROR_LOCATION__DRAG_AND_DROP:
			return dndMessages;
		case ERROR_LOCATION__GLOBAL_MORE_MENU:
			return moreMenuMessages;
		case ERROR_LOCATION__GLOBAL_SHORTCUTS:
			return shortcutsMessages;
		case ERROR_LOCATION__GLOBAL_SIDE_NAVIGATION:
			return sideNavMessages;
		default:
			return defaultMessages;
	}
}
